import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { getLayoutById } from "../../store/ducks/duckLayout";
import LayoutWithTabs from "../LayoutWithTabs";
import LoadingComponent from "../../components/LoadingComponent";

const Annual = () => {
  const dispatch = useDispatch();

  const id = 55;
  const { isLoading: isLoadingLayout } = useSelector((state) => state.layout);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    dispatch(getLayoutById(id)).then(() => setLoading(false));
  }, [dispatch, id]);

  return (
    <>
      {isLoadingLayout || loading ? (
        <LoadingComponent loading={isLoadingLayout} />
      ) : (
        <LayoutWithTabs isCustom={true} />
      )}
    </>
  );
};

export default React.memo(Annual);
